import { createAction, props } from '@ngrx/store';
import { SpendingTrendsElement, SpendingTrendsFilter } from '@core/domain/model/consumption/spending-trends.model';

export const spendingTrendsActions = {
  tabSelected: createAction('[Spending Trends Tabs] tab selected', props<{ tab: 'spending' | 'consumption' }>()),
  filterSpending: createAction('[Spending Trends Filter] filter spending', props<{ filter: SpendingTrendsFilter }>()),
  filterConsumption: createAction('[Spending Trends Filter] filter consumption', props<{ filter: SpendingTrendsFilter }>()),
  setSpending: createAction(
    '[Spending Trends API] spending response',
    props<{
      previous: SpendingTrendsElement[];
      current: SpendingTrendsElement[];
    }>()
  ),
  setPreviousConsumption: createAction('[Spending Trends API] previous consumption response', props<{ data: SpendingTrendsElement[] }>()),
  setCurrentConsumption: createAction('[Spending Trends API] current consumption response', props<{ data: SpendingTrendsElement[] }>()),
};
